import { FormattedMessage } from "react-intl";
import StudentResultOverview from "../StudentResultOverview";
import ClassResultOverview from "../ClassResultOverview";
import ProgramResultOverview from "../ProgramResultOverview";

export default function TeacherResultOverview({
  level,
  classData,
  student,
  studentId,
  studentHasLicense,
  programId,
}) {
  const renderLevel = () => {
    switch (level) {
      case "Class":
        return (
          <div>
            <ClassResultOverview classData={classData} />
          </div>
        );
      case "Student":
        if (studentHasLicense) {
          return (
            <StudentResultOverview
              studentEmail={student.email}
              studentId={studentId}
            />
          );
        } else {
          return (
            <div>
              <FormattedMessage id="StudentHasNoLicensesNoResults" />
            </div>
          );
        }
      case "Program":
        return <ProgramResultOverview programId={programId} />;

      default:
        return <div></div>;
    }
  };

  return <div>{renderLevel()}</div>;
}
